import classNames from 'classnames';
import React, { useMemo, useCallback } from 'react';
import { BackendSourceOptions, DiscoveryItemClickEvent, DiscoveryItemImpressionEvent } from '@udemy/browse-event-tracking';
import { TrackImpression, Tracker } from '@udemy/event-tracking';
import { useMatchMedia } from '@udemy/hooks';
import { formatRoundNumber, useI18n } from '@udemy/i18n';
import { SpotIllustration } from '@udemy/illustrations';
import { Carousel } from '@udemy/react-structure-components';
import { getRequestData } from '@udemy/shared-utils';
import { useUDData } from '@udemy/ud-data';
import { learnerCountForCategoryByCountry, categoryInfo, getHeadingForCategoriesModule, categoryModuleAllowedCountries } from '../utils/constants';
import styles from "./top-categories.module.css";
export const TopCategoriesComponent = ({
  headingLevel = 'h2',
  titleStyle = 'ud-heading-serif-xxl',
  categoryLevel = 'h3',
  categoryStyle = 'ud-heading-md',
  learnersCountStyle = 'ud-text-xs'
}) => {
  var _udConfig$price_count, _udConfig$price_count2;
  const requestData = getRequestData();
  const HeadingElement = headingLevel;
  const CategoryHeading = categoryLevel;
  const {
    gettext,
    interpolate
  } = useI18n();
  const isMobile = useMatchMedia('mobile-max');
  const {
    Config: udConfig
  } = useUDData();
  const priceCountryId = (_udConfig$price_count = (_udConfig$price_count2 = udConfig.price_country) === null || _udConfig$price_count2 === void 0 ? void 0 : _udConfig$price_count2.id) !== null && _udConfig$price_count !== void 0 ? _udConfig$price_count : '';
  const renderCard = useCallback((category, index) => {
    const categoryDetails = categoryInfo(gettext)[category.id];
    const clientEvent = {
      id: category.id,
      type: 'course_category',
      trackingId: String(category.id),
      serveTrackingId: String(category.id),
      backendSource: BackendSourceOptions.DISCOVERY,
      position: index,
      uiRegion: 'popular_categories',
      badgeFamilies: null,
      relatedSourceId: null,
      relatedSourceType: null
    };
    const trackImpression = function () {
      Tracker.publishEvent(new DiscoveryItemImpressionEvent(clientEvent));
    };
    const handleCategoryClick = function () {
      Tracker.publishEvent(new DiscoveryItemClickEvent(clientEvent));
    };
    return /*#__PURE__*/React.createElement(TrackImpression, {
      trackFunc: trackImpression,
      key: category.id
    }, /*#__PURE__*/React.createElement("a", {
      className: classNames('ud-custom-focus-visible'),
      href: `/courses/${categoryDetails.formatted}/`,
      onClick: handleCategoryClick
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles['category-card-layout']),
      id: 'category-' + categoryDetails.formatted
    }, /*#__PURE__*/React.createElement(SpotIllustration, {
      name: categoryDetails.illustration,
      alt: categoryDetails.translated,
      height: 120,
      width: 120
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles['category-text-div'])
    }, /*#__PURE__*/React.createElement("span", {
      className: "ud-heading-md ud-focus-visible-target"
    }, /*#__PURE__*/React.createElement(CategoryHeading, {
      className: classNames(categoryStyle, styles['category-card-text'])
    }, categoryDetails.translated)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: classNames(learnersCountStyle, styles['category-card-text'])
    }, interpolate(gettext('%(learnersCount)s learners'), {
      learnersCount: formatRoundNumber(category.learnersCount, 0, requestData.locale, {
        notation: 'compact',
        roundingMode: 'ceil'
      })
    }, true))))));
  }, [CategoryHeading, categoryStyle, learnersCountStyle, gettext, interpolate, requestData.locale]);
  const content = useMemo(() => {
    var _learnerCountForCateg;
    return (((_learnerCountForCateg = learnerCountForCategoryByCountry()) === null || _learnerCountForCateg === void 0 ? void 0 : _learnerCountForCateg[priceCountryId]) || []).map((category, index) => renderCard(category, index));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gettext, renderCard, priceCountryId]);
  return categoryModuleAllowedCountries.has(priceCountryId) ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['top-categories'])
  }, /*#__PURE__*/React.createElement(HeadingElement, {
    className: classNames(titleStyle, styles['section-title'])
  }, getHeadingForCategoriesModule(gettext, priceCountryId)), /*#__PURE__*/React.createElement("section", {
    className: classNames('ud-layout-5-course-card-row')
  }, /*#__PURE__*/React.createElement(Carousel, {
    className: classNames('carousel-5-course-cards-content-area'),
    pageByFullWidth: true,
    showPager: !isMobile,
    allowScroll: !!isMobile
  }, content))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
//# sourceMappingURL=top-categories.react-component.js.map